var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc-alert-success"},[_vm._v("Updated Successfully")])
}
var staticRenderFns = []

export { render, staticRenderFns }